export function calcDiffMarche(
  askingPrice: number | null | undefined,
  estimatedSalePrice: number | null | undefined,
): number | null {
  if (!askingPrice || !estimatedSalePrice) return null;
  return ((askingPrice - estimatedSalePrice) / estimatedSalePrice) * 100;
}
